import { render, staticRenderFns } from "./confetti.vue?vue&type=template&id=8a857528&scoped=true&"
import script from "./confetti.vue?vue&type=script&lang=js&"
export * from "./confetti.vue?vue&type=script&lang=js&"
import style0 from "./confetti.vue?vue&type=style&index=0&id=8a857528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a857528",
  null
  
)

export default component.exports